export const TIME_5000 = 5000;
